import { FC } from 'react';
import { HeaderStyled } from './style';

const Header: FC = ({ children, ...restProps }) => <HeaderStyled {...restProps}>{children}</HeaderStyled>;

export default Header;
